import React, {memo} from 'react';
import Chat from '../components/contacts/chat';
import {FolderType} from '../types';
import FolderPage from '../components/folder/folderpage';
import {ChatStackParams} from '../types/nav';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import FolderLibrary from '../components/folder/folderlibrary';
import {useFolders} from '../hooks/useFolders';
import {CameraScreen} from '../components/camera/camera';
import {useRoute} from '@react-navigation/native';
const folderType = FolderType.contact;

const ChatStack = createNativeStackNavigator<ChatStackParams>();

const FolderComponent = memo(() => (
  <FolderPage folderType={folderType} />
));
const FolderLibraryComponent = memo(() => (
  <FolderLibrary dataHook={useFolders(folderType, false)} />
));
export const createChatStack = () => {
  const ChatStackScreen = () => {
    return (
      <ChatStack.Navigator
        screenOptions={{
          headerShown: false,
          // freezeOnBlur: true,
        }}>
        <ChatStack.Screen
          name="Contacts"
          component={FolderLibraryComponent}
          options={
            {
              // freezeOnBlur: true,
            }
          }
        />
        <ChatStack.Screen
          name="Chat"
          component={ops => (
            <Chat {...ops} params={useRoute().params} />
          )}
          options={({route}) => ({
            // freezeOnBlur: true,
          })}
        />
        <ChatStack.Screen
          name="Camera"
          component={CameraScreen}
          options={({route}) => ({
            // freezeOnBlur: true,
          })}
        />
        <ChatStack.Screen
          name="Folder"
          component={FolderComponent}
          options={({route}) => ({
            freezeOnBlur: true,
          })}
        />
      </ChatStack.Navigator>
    );
  };
  return ChatStackScreen;
};
